import * as React from 'react';
import Project from 'src/entities/Project';
import ProjectFormalizationComponent, { ProjectFormalizationComponentProps } from './ProjectFormalization.component';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import Investment from 'src/entities/Investment';
import { getInvestment, GetInvestmentAction } from 'src/actions/investment/get/GetInvestment.actions';
import * as getInvestmentTypes from 'src/actions/investment/get/Types';
import Person from '../../../../entities/Person';
import { getUser, GetUserAction } from 'src/actions/user/get/GetUser.actions';
import * as updateInvestmentTypes from 'src/actions/investment/update/Types';
import User from 'src/entities/User';
import LoadingContainer from 'src/modules/commons/loading/Loading.container';
import { updateInvestment, UpdateInvestmentAction } from 'src/actions/investment/update/UpdateInvestment.actions';

interface StateProps {
  investment?: Investment;
  activeProfile?: Person;
  loggedUserData: number | null;
  user?: User;
  loading: boolean;
}

interface DispatchProps {
  updateInvestment(investment: Investment): Promise<UpdateInvestmentAction>;

  getInvestment(projectId: number, profileId: number, profileType: string): Promise<GetInvestmentAction>;

  getUser(userId: number): Promise<GetUserAction>;
}

interface Props extends StateProps, DispatchProps {
  project: Project;
  investedUser: boolean;
  activePayment: boolean;
  handleChangeTab: (value: string) => void;
}

interface State {
  step: string;
}

class ProjectFormalizationContainer extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      step: props.investment && props.investment.status || 'Reviewing Profile',
    };
  }

  public componentWillReceiveProps(newProps: Props) {
    if (newProps.investment !== undefined && newProps.investment.status) {
      this.setState(
        {
          step: newProps.investment.status
        }

      );
    }
  }

  public render(): React.ReactNode {
    if (
      !this.props.investedUser ||
      !this.props.investment ||
      !this.props.activeProfile
    ) {
      return <LoadingContainer/>;
    }

    return (
      <ProjectFormalizationComponent {...this.getComponentProps()} />
    );
  }

  private getComponentProps(): ProjectFormalizationComponentProps {
    if (!this.props.investment || !this.props.activeProfile) {
      throw Error('there is no investment or physical person');
    }
    return {
      project: this.props.project,
      step: this.state.step,
      setStep: (step: string) => this.setStep(step),
      investment: this.props.investment,
      person: this.props.activeProfile,
      activePayment: this.props.activePayment,
      formalizationIsLoading: this.props.loading,
      setInvestment: (investment: Investment, step: string) => this.setInvestment(investment, step),
      handleChangeTab: this.props.handleChangeTab,
    };
  }

  private setInvestment(investment: Investment, step: string) {
    this.props.updateInvestment(investment)
      .then((updateInvestmentResponse) => {
        if (updateInvestmentResponse.type === updateInvestmentTypes.UPDATE_INVESTMENT_SUCCESS) {
          this.props.getInvestment(
            this.props.project.id,
            this.props.activeProfile!.id,
            this.props.activeProfile!.personType).then((getInvestmentResponse) => {
            if (getInvestmentResponse.type === getInvestmentTypes.GET_INVESTMENT_SUCCESS) {
              this.setStep(step);
            }
          });

        }
      });
  }

  private setStep(step: string): void {
    this.setState({step: step});
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
  getInvestment: (
    projectId: number,
    profileId: number,
    profileType: string
  ): Promise<GetInvestmentAction> => (
    dispatch(getInvestment(projectId, profileId, profileType))
  ),
  getUser: (userId: number): Promise<GetUserAction> => (
    dispatch(getUser(userId))
  ),
  updateInvestment: (investment: Investment): Promise<UpdateInvestmentAction> => (
    dispatch(updateInvestment(investment))
  ),
});

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  investment: state.getInvestment.investment,
  activeProfile: state.getUser.activeProfile,
  loggedUserData: state.authentication.loggedUserData,
  user: state.getUser.user,
  loading: state.getInvestment.loading
});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectFormalizationContainer);



// WEBPACK FOOTER //
// ./src/modules/project/partials/project-formalization/ProjectFormalization.container.tsx